import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PObject } from '../../models/object';
import { OptionService } from '../../shared/option.service';
import { ObjectService } from '../../shared/object.service';
import { ActiveModal } from '../../core/modal.service';
import { ModalComponent } from '../../core/modal.component';
import { Project } from '../../models/project';
import { WidgetMapRegion } from '../../models/widget';

@Component({
  selector: 'cw-edit-object-modal',
  templateUrl: './edit-object-modal.component.html',
  styleUrls: ['./edit-object-modal.component.scss']
})
export class EditObjectModalComponent extends ModalComponent implements OnInit {
  form: FormGroup;
  changed: EventEmitter<PObject> = new EventEmitter<PObject>();
  isSaving: boolean = false;
  object: PObject;
  errorMessage: any;
  statusOptions: { value: string; label: any }[];
  project: Project;
  regions: WidgetMapRegion[];
  isDeleting: boolean;

  constructor(private fb: FormBuilder,
              private optionService: OptionService,
              private objectService: ObjectService,
              public activeModal: ActiveModal) {
    super(activeModal);
    this.createForm();
    this.statusOptions = this.optionService.objectStatusOptions;
  }

  ngOnInit() {
  }

  init(project: Project, object?: PObject) {
    this.project = project;
    if (object) {
      this.object = object;
      this.objectService.getRegions(this.object).subscribe(regions => {
        this.regions = regions;
      });
      this.updateForm();
    } else {
      this.object = new PObject();
    }

    this.opened = true;
  }

  save() {
    if (!this.form.valid) {
      this.errorMessage = 'Fel på formulär';
      return;
    }

    this.isSaving = true;
    this.errorMessage = null;

    this.object = this.prepareSave();

    if (this.object.id) {
      this.objectService.update(this.object)
        .finally(() => this.isSaving = false)
        .subscribe(obj => {
          console.log(obj);
          this.changed.emit(obj);
          this.activeModal.close(obj);
        }, err => {
          this.errorMessage = err;
        });
    } else {
      this.objectService.create(this.object, this.project)
        .finally(() => this.isSaving = false)
        .subscribe(obj => {
          console.log(obj);
          this.changed.emit(obj);
          this.activeModal.close(obj);
        }, err => {
          this.errorMessage = err;
        });
    }
  }

  destroy() {
    this.isDeleting = true;
    this.objectService.destroy(this.object)
      .finally(() => this.isDeleting = false)
      .subscribe(() => {
        this.activeModal.close(null);
      });
  }

  private createForm() {
    this.form = this.fb.group({
      number: ['', Validators.required],
      status: ['', Validators.required],
      living_area: [''],
      balcony_area: [''],
      floor: [''],
      rooms: [''],
      price: [''],
      monthly_fee: [''],
      balcony_view: [''],
    });
  }

  get isExisting() {
    return this.object && !!this.object.id;
  }

  private updateForm() {
    this.form.setValue({
      number: this.object.number,
      living_area: this.object.livingArea,
      balcony_area: this.object.balconyArea,
      balcony_view: this.object.balconyView,
      status: this.object.status || null,
      floor: this.object.floorNumber,
      rooms: this.object.rooms,
      price: this.object.price || null,
      monthly_fee: this.object.monthlyFee,
    });

    if (this.object.readonly) {
      this.form.disable();
    }
  }

  private prepareSave() {
    const formModel = this.form.value;

    const obj = new PObject({
        id: this.object.id,
        status: formModel.status,
        number: formModel.number,
        floor_number: formModel.floor,
        rooms: formModel.rooms,
        price: { amount: formModel.price },
        monthly_fee: { amount: formModel.monthly_fee },
        living_area: formModel.living_area,
        balcony_area: formModel.balcony_area,
        balcony_view: formModel.balcony_view,
        url: this
          .object.url
      }
    );

    return obj;
  }

  get hasRegions() {
    return this.regions && this.regions.length > 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/edit-object-modal/edit-object-modal.component.ts